var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconWarn = function SvgIconWarn(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1a6.999 6.999 0 1 0 0 13.998A6.999 6.999 0 0 0 8 1m.148 1.002a6 6 0 0 1 4.84 2.664 6 6 0 0 1-.746 7.576 5.999 5.999 0 1 1-4.094-10.24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.583 11.126a.75.75 0 1 1 .834 1.248.75.75 0 0 1-.834-1.248M7.5 4v5.5h1V4Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconWarn);
export { ForwardRef as ReactComponent };